import { useBusinessTicketsRequests } from "../../company-office/business-tickets-v2/hooks";
import { useExternalVehicleTravelCardRequests } from "../../company-office/external-vehicle-travel-card/hooks";
import { useVehicleRequests } from "../../company-office/request-vehicle/hooks";
import { useSecurityCardUnitsRequests } from "../../company-office/securityCardUnits/hooks/use-security-card-units-requests";
import { useSecurityControlCardRequests } from "../../company-office/sercurity-control-card/hooks";
import { useVehicleTravelCardRequests } from "../../company-office/vehicle-travel-card/hooks";

export const useCompanyOfficeRequests = () => {
  const { isLoading: isLoading1, vehicleRequests, vehicleMyRequests } = useVehicleRequests();
  const {
    isLoading: isLoading2,
    vehicleTravelCardRequests,
    vehicleTravelCardMyRequests,
  } = useVehicleTravelCardRequests();
  const {
    isLoading: isLoading3,
    securityControlCardRequests,
    securityControlCardMyRequests,
  } = useSecurityControlCardRequests();
  const {
    isLoading: isLoading4,
    securityCardUnitsRequests,
    securityCardUnitsMyRequests,
  } = useSecurityCardUnitsRequests();
  const { isLoading: isLoading5, businessTicketsRequests, businessTicketsMyRequests } = useBusinessTicketsRequests();
  const {
    isLoading: isLoading6,
    externalVehicleTravelCardRequests,
    externalVehicleTravelCardMyRequests,
  } = useExternalVehicleTravelCardRequests();

  const totalCompanyOfficeRequests =
    vehicleRequests.length +
    vehicleTravelCardRequests.length +
    securityControlCardRequests.length +
    securityCardUnitsRequests.length +
    businessTicketsRequests.length +
    externalVehicleTravelCardRequests.length;

  const totalCompanyOfficeMyRequests =
    vehicleMyRequests.length +
    vehicleTravelCardMyRequests.length +
    securityControlCardMyRequests.length +
    securityCardUnitsMyRequests.length +
    businessTicketsMyRequests.length +
    externalVehicleTravelCardMyRequests.length;

  const allCompanyOfficeRequests = [
    ...vehicleRequests,
    ...vehicleTravelCardRequests,
    ...securityControlCardRequests,
    ...securityCardUnitsRequests,
    ...businessTicketsRequests,
    ...externalVehicleTravelCardRequests,
  ];
  const allCompanyOfficeMyRequests = [
    ...vehicleMyRequests,
    ...vehicleTravelCardMyRequests,
    ...securityControlCardMyRequests,
    ...securityCardUnitsMyRequests,
    ...businessTicketsMyRequests,
    ...externalVehicleTravelCardMyRequests,
  ];

  const isLoading = isLoading1 || isLoading2 || isLoading3 || isLoading4 || isLoading5 || isLoading6;

  return {
    isLoading,
    totalCompanyOfficeRequests,
    totalCompanyOfficeMyRequests,
    allCompanyOfficeRequests,
    allCompanyOfficeMyRequests,
  };
};
